import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Facebook Stories on mobile. */
@Component({
  selector: 'app-meta-facebook-stories-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-stories-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    './facebook-stories-mobile.component.scss',
  ]
})
export class MetaFacebookStoriesMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
